import React from "react";
import { Divider } from "@mui/material";
import PropTypes from "prop-types";

const defaultProps = {
  color: "white",
};

export const Delimiter = ({ color }) => {
  return <Divider data-testid="divider" sx={{ borderColor: color }} />;
};

Delimiter.propTypes = {
  color: PropTypes.string.isRequired,
};

Delimiter.defaultProps = defaultProps;

export default Delimiter;
